import script from "./TearCard.vue?vue&type=script&setup=true&lang=js"
export * from "./TearCard.vue?vue&type=script&setup=true&lang=js"

import "./TearCard.vue?vue&type=style&index=0&id=0f396326&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f396326"]])

export default __exports__